import { useContext, useEffect, useState } from "react"
import { ToolContext } from "../../../core/context/ToolContext";
import { env } from "../../../core/Env";
import { rqx } from "../../../core/request/API";
import { isMobile, isTablet } from "react-device-detect";
import { GetRandomThreeResult } from "../toolUsage/global/Format";
import moment from "moment";
import axios from "axios";

// const tool_id =  process.env.REACT_APP_TID_PSL;
// const global_id = process.env.REACT_APP_GLOBAL_ID;

export const RenderAPI = () => {
    const { tool_state } = useContext(ToolContext)
    const { __SESSION, globalLoader, toolOwned, validateAccount, toolShuffle} = tool_state

    const __init = async() => {
        await globalLoader.set(true)
        // await __runactiveuser()
       
        //GET TOOL OWNED
        let prms = {aid:__SESSION.data.ainfo.aid, platform:'personal' } 
        let resTool = await rqx.get(`<<global>>/${env()==='local'?'dev':env()}/tools/owned`, prms)
        if (window.atob(__SESSION.data.ainfo.aid).split('_')[1] !== '0') { 
            const res = await axios.get("https://ipapi.co/json/");
            const location = JSON.stringify(res.data)
            const ipaddress = res.data.ip    
            let body = {
                action:"signin",
                aid: __SESSION.data.ainfo.aid,
                date: moment(new Date()).format('YYYY-MM-DD'),
                tool_id: process.env.REACT_APP_TID_PSL, 
                location:location,
                ip_address:ipaddress,
                device_type: isMobile? 2 : isTablet ? 3 : 1
            }
            await rqx.post(`<<global>>/${env()}/trail/create`, body)
        }
        
        // const res_city = await rqx.get(`<<global>>/${env()}/location/city`, { ref: 'province_id', filter: JSON.stringify([vl[0].province_id]) });
        // const res_barangay = await rqx.get(`<<global>>/${env()}/location/barangay`, { ref: 'city_id', filter: JSON.stringify([vl[0].city_id]) });
        toolOwned.set(resTool)
        if (resTool.length > 3) { 
            const result = GetRandomThreeResult(resTool); 
            toolShuffle.set(result) 
        }

        await globalLoader.set(false)
    }

    const [subscribe, setSubscribe] = useState(true)
  
    useEffect(() => {
        if (subscribe) {
            if (globalLoader.data) {
                if (__SESSION.data.ainfo !== null) {
                    __init()
                }
            }
        }
        return () => setSubscribe(false)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [validateAccount.data])
    
    return (
        <></>
    )
}